import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { RANKR_FAQS } from '@/data/rankr';

export default function RankrFaq() {
  return (
    <section className="bg-[#0B0B0B] border-t border-white/10 py-16 lg:py-24">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10">
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6]">Questions</p>
        <h2 className="mt-4 font-display font-bold text-white text-3xl lg:text-[2.5rem] tracking-tight leading-tight">Before you start</h2>
        <Accordion type="single" collapsible className="mt-10">
          {RANKR_FAQS.map((f) => (
            <AccordionItem key={f.q} value={f.q} className="border-white/10">
              <AccordionTrigger className="text-left text-white hover:text-[#3B82F6] font-display font-semibold text-base">{f.q}</AccordionTrigger>
              <AccordionContent className="text-white/55 text-sm leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}